import React, { useEffect, useState } from 'react'
import { getTotalProcedimientosQx } from '../../../services/FarmaciaRuta'

const ModalTotalProcedimientosQx = () => {
    const [dataProcedimientos, setdataProcedimientos]=useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    // Agregado: un nuevo estado para mantener los datos después de que se aplica el filtro.
    const [filteredData, setFilteredData] = useState([]);
    // Agregado: un nuevo estado para mantener el término de búsqueda actual.
    const [searchTerm, setSearchTerm] = useState("");
    useEffect(()=>{
        getTotalProcedimientosQx().then((res)=>{
            console.log(res.data.data,'total procedimientos')
            setdataProcedimientos(res.data.data)
        })
    },[])
    // Agregado: un nuevo efecto que se ejecuta cuando el término de búsqueda o los datos cambian.
    // Filtra los datos en función del término de búsqueda y guarda los resultados en filteredData.
    useEffect(() => {
        if (searchTerm !== "") {
        setFilteredData(dataProcedimientos.filter((row) =>
            row.PRCODI.toString().includes(searchTerm) || row.PrNomb.toLowerCase().includes(searchTerm.toLowerCase())
        ));
        } else {
        setFilteredData(dataProcedimientos);
        }
        // Cuando el término de búsqueda cambia, también restablecemos la página actual a 1.
        setCurrentPage(1);
    }, [searchTerm, dataProcedimientos]);

        const lastIndex = currentPage * rowsPerPage;
        const firstIndex = lastIndex - rowsPerPage;
        const currentRows = filteredData.slice(firstIndex, lastIndex);

        // Ahora calculamos las páginas totales basadas en los datos filtrados, no todos los datos.
        const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  return (
    <div className='p-4'>
    <div className="my-4">
        <input 
            type="text"
            placeholder="Buscar por código o suministro..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="
            p-2 
            w-full 
            border-2 
            border-blue-500
            rounded-lg 
            focus:outline-none 
            focus:ring-2 
            focus:ring-blue-600 
            focus:border-transparent
            shadow-md"
        />
    </div>
        <table className="table-auto w-full shadow-md rounded-lg overflow-hidden">
            <thead>
                <tr className="bg-gray-300 text-gray-700">
                    <th className="px-4 py-2">Código</th>
                    <th className="px-4 py-2">Nombre del Procedimiento</th>
                    <th className="px-4 py-2 cursor-pointer" >Cantidad Procedimiento</th>
                    
                </tr>
            </thead>
            <tbody>
            {currentRows.map((row, index) => (
                <tr className={index % 2 === 0 ? 'bg-gray-100' : ''} key={row.PRCODI}>
                <td className="border px-4 py-2">{row.PRCODI}</td>
                <td className="border px-4 py-2">{row.PrNomb}</td>
                <td className="border px-4 py-2">{row.Cantidad}</td>                
                </tr>
            ))}
            </tbody>
    </table>

    <div className="flex items-center justify-between mt-4">
            <div>
            <label htmlFor="pagination" className="mr-2">
                Filas por página:
            </label>
            <select
                id="pagination"
                value={rowsPerPage}
                onChange={(e) => {
                setRowsPerPage(parseInt(e.target.value));
                setCurrentPage(1);
                }}
                className="rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
            </select>
            </div>

            <div>
            <button
                onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
                disabled={currentPage === 1}
                className={`mx-1 py-1 px-3 rounded bg-indigo-500 text-white ${
                currentPage === 1 && "opacity-50 cursor-not-allowed"
                }`}
            >
                Anterior
            </button>

            <span>{`${currentPage} de ${totalPages}`}</span>

            <button
                onClick={() =>
                setCurrentPage((page) => Math.min(page + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className={`mx-1 py-1 px-3 rounded bg-indigo-500 text-white ${
                currentPage === totalPages && "opacity-50 cursor-not-allowed"
                }`}
            >
                Siguiente
            </button>
            </div>
        </div>
</div>
  )
}

export default ModalTotalProcedimientosQx